import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit'

export const createAppSlice = buildCreateSlice({
    creators: { asyncThunk: asyncThunkCreator },
})